import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { UiComponent } from 'components';
import { IQuestion } from 'types';
import { EventAdditionalQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
function Additional() {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isLoading } = EventAdditionalQuery.useGet(id || '');
  const { mutate: create } = EventAdditionalQuery.useCreate();
  const { mutate: update } = EventAdditionalQuery.useUpdate();

  const handleDone = () => {
    toast.success('추가정보 저장완료');
    navigate(-1);
  };

  const onCreate = (title: string, questions: IQuestion[]) => {
    if (!id) return;
    const data = { id, title, questions: JSON.stringify(questions) };
    create(data, {
      onSuccess: handleDone,
      onError: () => {
        toast.error(DEFAULT_ERROR_MESSAGE);
      },
    });
  };

  const onUpdate = (title: string, questions: IQuestion[]) => {
    if (!id || !data) return;

    update(
      { id: data.id, title, questions: JSON.stringify(questions) },
      {
        onSuccess: handleDone,
        onError: () => {
          toast.error(DEFAULT_ERROR_MESSAGE);
        },
      },
    );
  };

  const handleSave = (title: string, questions: IQuestion[]) => {
    if (data) onUpdate(title, questions);
    else onCreate(title, questions);
  };

  if (isLoading) return null;

  return (
    <div>
      <UiComponent.Forms
        formData={{ title: data?.title, questions: data?.questions }}
        type={'additional'}
        onSave={handleSave}
      />
    </div>
  );
}

export default Additional;
